import React, { Component } from 'react';

class ProfilePage extends Component {
    render() {
        const { user } = this.props;

        return (
            <React.Fragment>
            {user && 
                <div className="card" style={{width: "18rem", margin: "auto"}}>
                  <div className="card-body">
                    <h5 className="card-title text-center">{user.username}</h5>
                    <p className="card-text">
                        <strong>Email:</strong> {' '} {user.email}
                    </p>
                    <p className="card-text">
                        <strong>Account Type:</strong> {' '} {user.user_type}
                    </p>
                  </div>
                </div>
            }
            </React.Fragment>
        );
    }
}

export default ProfilePage;